/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApplicationScope } from './ApplicationScope';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeFromJSONTyped,
    ApplicationScopeToJSON,
} from './ApplicationScope';
import type { Invoice } from './Invoice';
import {
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
} from './Invoice';
import type { SubscriptionStatus } from './SubscriptionStatus';
import {
    SubscriptionStatusFromJSON,
    SubscriptionStatusFromJSONTyped,
    SubscriptionStatusToJSON,
} from './SubscriptionStatus';

/**
 * 
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    customerId?: string;
    /**
     * 
     * @type {ApplicationScope}
     * @memberof Subscription
     */
    tenant?: ApplicationScope;
    /**
     * the associated product
     * @type {string}
     * @memberof Subscription
     */
    productId?: string;
    /**
     * associated order
     * @type {string}
     * @memberof Subscription
     */
    orderId?: string;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof Subscription
     */
    status?: SubscriptionStatus;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    validFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    validTo?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Subscription
     */
    autoRenew?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    lastPayment?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    nextRenewal?: Date;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    outstandingBalance?: number;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    cancellationDate?: Date;
    /**
     * 
     * @type {Array<Invoice>}
     * @memberof Subscription
     */
    invoices?: Array<Invoice>;
}

/**
 * Check if a given object implements the Subscription interface.
 */
export function instanceOfSubscription(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubscriptionFromJSON(json: any): Subscription {
    return SubscriptionFromJSONTyped(json, false);
}

export function SubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subscription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'tenant': !exists(json, 'tenant') ? undefined : ApplicationScopeFromJSON(json['tenant']),
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'orderId': !exists(json, 'orderId') ? undefined : json['orderId'],
        'status': !exists(json, 'status') ? undefined : SubscriptionStatusFromJSON(json['status']),
        'validFrom': !exists(json, 'validFrom') ? undefined : (new Date(json['validFrom'])),
        'validTo': !exists(json, 'validTo') ? undefined : (new Date(json['validTo'])),
        'autoRenew': !exists(json, 'autoRenew') ? undefined : json['autoRenew'],
        'lastPayment': !exists(json, 'lastPayment') ? undefined : (new Date(json['lastPayment'])),
        'nextRenewal': !exists(json, 'nextRenewal') ? undefined : (new Date(json['nextRenewal'])),
        'outstandingBalance': !exists(json, 'outstandingBalance') ? undefined : json['outstandingBalance'],
        'cancellationDate': !exists(json, 'cancellationDate') ? undefined : (new Date(json['cancellationDate'])),
        'invoices': !exists(json, 'invoices') ? undefined : ((json['invoices'] as Array<any>).map(InvoiceFromJSON)),
    };
}

export function SubscriptionToJSON(value?: Subscription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'customerId': value.customerId,
        'tenant': ApplicationScopeToJSON(value.tenant),
        'productId': value.productId,
        'orderId': value.orderId,
        'status': SubscriptionStatusToJSON(value.status),
        'validFrom': value.validFrom === undefined ? undefined : (value.validFrom.toISOString()),
        'validTo': value.validTo === undefined ? undefined : (value.validTo.toISOString()),
        'autoRenew': value.autoRenew,
        'lastPayment': value.lastPayment === undefined ? undefined : (value.lastPayment.toISOString()),
        'nextRenewal': value.nextRenewal === undefined ? undefined : (value.nextRenewal.toISOString()),
        'outstandingBalance': value.outstandingBalance,
        'cancellationDate': value.cancellationDate === undefined ? undefined : (value.cancellationDate.toISOString()),
        'invoices': value.invoices === undefined ? undefined : ((value.invoices as Array<any>).map(InvoiceToJSON)),
    };
}

